<h1 class="section-title">{{ character.name }}</h1>
@for (block of character.getExperience(); track block) {
  <h2 class="section-subtitle">
  Level {{ block.currentLevel() }} {{ character.race }} {{ block.class }}</h2>
}
<div id="overview" class="container">
  <mat-card appearance="outlined">
    <mat-card-content>
      @if (editing!='stats') {
        <mat-icon color='primary' (click)="editSection('stats')" class="edit">edit</mat-icon>
      }
      @if (editing!='stats') {
        <mat-list>
          <h2>Stats</h2>
          <mat-list-item overflowTooltip><span>Name: &nbsp;</span> {{ character.name }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Class: &nbsp;</span> {{ character.getConciseClassLevelString() }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Age: &nbsp;</span> {{ character.age }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Sex: &nbsp;</span> {{ character.sex }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Race: &nbsp;</span> {{ character.race }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Primary Hand: &nbsp;</span> {{ character.handedness }}</mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>
      }
      @if (editing=='stats') {
        <div class="editing">
          <h2>Edit Stats</h2>
          <mat-list>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Name:</mat-label>
                <input matInput [(ngModel)]="character.name"/>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Age:</mat-label>
                <input matInput [(ngModel)]="character.age" type="number"/>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Sex:</mat-label>
                <input matInput [(ngModel)]="character.sex"/>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Race:</mat-label>
                <input matInput [(ngModel)]="character.race"/>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <mat-form-field>
                <mat-label>Primary Hand:</mat-label>
                <mat-select [(ngModel)]="character.handedness">
                  @for (hand of handednessOptions; track hand) {
                    <mat-option [value]="hand">{{ hand }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-list-item>
            <mat-list-item>
              <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
            </mat-list-item>
          </mat-list>
        </div>
      }
    </mat-card-content>
  </mat-card>
  <mat-card appearance="outlined">
    <mat-card-content>
      @if (editing!='background') {
        <mat-icon color='primary' (click)="editSection('background')" class="edit">edit
        </mat-icon>
      }
      @if (character.hasPositiveAbilityAdjustment('intelligence')) {
        <mat-icon color="primary" class="ability-info-icon"
          matTooltip="Your high intellect compels to you one additional spoken language for each point above 10 ">
          info
        </mat-icon>
      }
      @if (character.hasNegativeAbilityAdjustment('intelligence')) {
        <mat-icon color="primary" class="ability-info-icon"
          matTooltip="Your weak intellect renders you unable to read or write">info
        </mat-icon>
      }
      @if (editing!='background') {
        <mat-list>
          <h2>Background</h2>
          <mat-list-item overflowTooltip><span>Alignment:&nbsp;</span> {{ character.alignment }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item overflowTooltip><span>Land of Origin:&nbsp;</span> {{ character.origin }}</mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item>
            <span>Profession:&nbsp;</span>
            <span class="profession" [matTooltip]="professionTooltip()">{{ character.profession }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </mat-list>
        <div class="languages">
          <span class="languages-label">Known Languages:</span>
          @if (character.known_languages?.length) {
            <mat-chip-set>
              @for (language of character.known_languages; track $index) {
                <mat-chip [title]="language">{{ language }}</mat-chip>
              }
            </mat-chip-set>
          } @else {
            <em>None</em>
          }
        </div>
      }
    @if (editing=='background') {
      <mat-list class="editing">
        <h2>Edit Background</h2>
        <mat-list-item>
          <mat-form-field>
            <mat-label>Alignment:</mat-label>
            <input matInput [(ngModel)]="character.alignment"/>
          </mat-form-field>
        </mat-list-item>
        <mat-list-item>
          <mat-form-field>
            <mat-label>Land of Origin:</mat-label>
            <input matInput [(ngModel)]="character.origin"/>
          </mat-form-field>
        </mat-list-item>
        <mat-list-item>
          <mat-form-field>
            <mat-label>Profession:</mat-label>
            <input matInput [(ngModel)]="character.profession"/>
          </mat-form-field>
        </mat-list-item>
      </mat-list>
      <div class="languages-edit">
        <mat-form-field>
          <mat-label>Known Languages:</mat-label>
          <mat-chip-grid #languageChips>
            @for (language of character.known_languages; track $index) {
              <mat-chip-row (removed)="removeLanguage($index)">
                {{ language }}
                <button matChipRemove [attr.aria-label]="'Remove ' + language">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
          <input placeholder="Add a language..." [matChipInputFor]="languageChips"
                 [matChipInputSeparatorKeyCodes]="languageSeparators" [matChipInputAddOnBlur]="true"
                 (matChipInputTokenEnd)="addLanguage($event)"/>
        </mat-form-field>
        <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
      </div>
    }
  </mat-card-content>
</mat-card>
<mat-card appearance="outlined">
  <mat-card-content>
    @if (editing!='attributes') {
      <mat-icon color='primary' (click)="editSection('attributes')" class="edit">edit
      </mat-icon>
    }
    @if (editing!='attributes') {
      <mat-list>
        <h2>Attributes</h2>
        <mat-list-item overflowTooltip>
        <span>Height / Weight: &nbsp;</span>{{ character.displayHeight() }} / {{ character.calculatedWeight() }}lbs
      </mat-list-item>
      <mat-divider></mat-divider>
    <mat-list-item overflowTooltip>
      <span>Hair:&nbsp;</span> {{ character.hair_length }} {{ character.hair_style }} {{ character.hair_color }}
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item overflowTooltip><span>Eyes:&nbsp;</span> {{ character.eye_color }} Eyes</mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item overflowTooltip>
      <span>Skin:&nbsp; </span>{{ character.skin_color }} Skin
    </mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item overflowTooltip><span>Teeth:&nbsp;</span> {{ character.dental_status }}</mat-list-item>
    <mat-divider></mat-divider>
    <mat-list-item overflowTooltip><span>Quirk:&nbsp;</span> {{ character.identifying_quality }}</mat-list-item>
    <mat-divider></mat-divider>
  </mat-list>
}
@if (editing=='attributes') {
  <mat-list class="editing">
    <h2>Edit Attributes</h2>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Height Feet:</mat-label>
        <input matInput [(ngModel)]="character.height_foot" type="number"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Height Inches:</mat-label>
        <input matInput [(ngModel)]="character.height_inch" type="number"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Weight Class:</mat-label>
        <mat-select [(ngModel)]="character.weight_class">
          @for (weightClass of weightClasses; track weightClass) {
            <mat-option [value]="weightClass">{{ weightClass | titlecase }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Hair Color:</mat-label>
        <input matInput [(ngModel)]="character.hair_color"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Hair Length:</mat-label>
        <input matInput [(ngModel)]="character.hair_length"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Hair Style:</mat-label>
        <input matInput [(ngModel)]="character.hair_style"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Eye Color:</mat-label>
        <input matInput [(ngModel)]="character.eye_color"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Skin Color:</mat-label>
        <input matInput [(ngModel)]="character.skin_color"/>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Dental Status:</mat-label>
        <mat-select [(ngModel)]="character.dental_status">
          @for (status of dentalOptions; track status) {
            <mat-option [value]="status">{{ status }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <mat-form-field>
        <mat-label>Quirk:</mat-label>
        <input matInput [(ngModel)]="character.identifying_quality" (ngModelChange)="filterIdentifyingQualities()"
               [matAutocomplete]="qualityAuto"/>
        <mat-autocomplete #qualityAuto="matAutocomplete">
          @for (quality of filteredIdentifyingQualities; track quality) {
            <mat-option [value]="quality">{{ quality }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </mat-list-item>
    <mat-list-item>
      <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
    </mat-list-item>
  </mat-list>
}
</mat-card-content>
</mat-card>
<mat-card appearance="outlined" id="movement">
  <mat-card-content>
    <h2>Movement</h2>
    @if (editing!='movement') {
      <mat-icon color='primary' (click)="editSection('movement')" class="edit">edit
      </mat-icon>
    }
    @if (editing!='movement') {
      <mat-list>
        <mat-list-item overflowTooltip><span>Base Movement:&nbsp;</span>{{ character.base_movement }}</mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item overflowTooltip>
          <span>Encumbrance:&nbsp;</span>{{ character.encumbranceLevel() }} ({{ character.encumbrance() | percent }})
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item overflowTooltip><span>Movement Rating:&nbsp;</span>{{ character.movementRating() }}</mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item overflowTooltip><span>1 Pace:&nbsp;</span>{{ character.movementRating() / 6 }}</mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item overflowTooltip><span>2 Pace:&nbsp;</span>{{ character.movementRating() / 3 }}</mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item overflowTooltip><span>3 Pace:&nbsp;</span>{{ character.movementRating() / 2 }}</mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    }
    @if (editing=='movement') {
      <mat-list class="editing">
        <mat-list-item>
          <mat-form-field>
            <mat-label>Base Movement:</mat-label>
            <input matInput [(ngModel)]="character.base_movement" type="number"/>
          </mat-form-field>
        </mat-list-item>
        <mat-list-item>
          <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
        </mat-list-item>
      </mat-list>
    }
  </mat-card-content>
</mat-card>
</div>
<div id="overview-stats" class="container">
  <mat-card appearance="outlined">
    <h4>Hit Dice</h4>
    <strong>{{ character.hitDice().base }} @if (character.hitDice().bonus != 0) {
      <span
      >+ {{ character.hitDice().bonus }}&nbsp;</span>
    }</strong>
  </mat-card>
  <mat-card appearance="outlined">
    @if (editing!='hitpoints') {
      <mat-icon color='primary' (click)="editSection('hitpoints')" class="edit">edit
      </mat-icon>
    }
    @if (editing!='hitpoints' && character.hasPositiveAbilityAdjustment('constitution')) {
      <mat-icon color="primary"
        class="ability-info-icon"
        matTooltip="Your high constitution compels to you an additional hit point for per whole hit die">info
      </mat-icon>
    }
    <h4>Hit Points</h4>
    @if (editing!='hitpoints') {
      <div>
        <strong><span class="current-hp">{{ character.current_hp }}</span> / {{ character.total_hp }}<span
      id="hpmax">Max</span></strong>
      <div id="hp-area">
        <button (click)="changeCharacter('current_hp',-1)" class="hp-button current-remove" mat-mini-fab color="warn">
          <mat-icon>remove</mat-icon>
        </button>
        <button [disabled]="character.current_hp==character.total_hp" (click)="changeCharacter('current_hp',1)"
          class="hp-button current-add" mat-mini-fab color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  }
  @if (editing=='hitpoints') {
    <div class="editing">
      <mat-form-field>
        <mat-label>Maximum Hitpoints:</mat-label>
        <input matInput type="number" min="0" [(ngModel)]="character.total_hp"/>
      </mat-form-field>
      <button mat-raised-button color="primary" (click)="doneEditing()">Done</button>
    </div>
  }
</mat-card>
<mat-card appearance="outlined">
  <h4>Armor Class</h4>
  <div id="armor-class">
    <div>
      <button (click)="changeCharacter('armor_class', -1)" color="warn" mat-icon-button class="remove-ac-button">
        <mat-icon>remove</mat-icon>
      </button>
      <strong>{{ character.armor_class }}</strong>
      <button (click)="changeCharacter('armor_class', 1)" color="primary" mat-icon-button class="add-ac-button">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    @if (character.shield) {
      <div>
        <strong>{{ character.armor_class - 1 }}</strong>
        <br/>
        <small>Shield</small>
      </div>
    }
  </div>
  <small>
    <mat-checkbox [(ngModel)]="character.helmet">Helmet</mat-checkbox>
    <br/>
    <mat-checkbox [(ngModel)]="character.shield">Shield</mat-checkbox>
  </small>
</mat-card>
<mat-card appearance="outlined">
  <h4>Melee To-hit</h4>
  <strong>+{{ character.meleeToHit() }}</strong>
  @if (character.hasPositiveAbilityAdjustment('strength')) {
    <p class="damage-modifier">+1 damage</p>
  }
</mat-card>
<mat-card appearance="outlined">
  <h4>Missile To-hit</h4>
  <strong>+{{ character.missileToHit() }}</strong>
  @if (character.hasPositiveAbilityAdjustment('dexterity')) {
    <p class="damage-modifier">+1 damage</p>
  }
</mat-card>
</div>

